module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76XHK"))).then(() => module.bundle.root('cvs7o'));